import { put } from "redux-saga/effects";

export function* cput(actionCreator, payload) {
  //conditional put
  if (payload) {
    yield put(actionCreator(payload));
  }
}
